// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UFSqw","paper":"styles_paper__l3pM2"};